export enum EmailTemplateEnum {
	BUGATTI = 'BUGATTI_RETURN_REQUEST',
	BAGATT = 'BAGATT_RETURN_REQUEST',
	SALAMANDER = 'SALAMANDER_RETURN_REQUEST',
}